<viewer-pdf-toolbar *ngIf="showPdf" [base64PdfModal]="base64PdfModal" (incrementPage)="incrementPage($event)" (incrementZoom)="incrementZoom($event)" (viewPages)="viewPages($event)" [numPages]="numPages" [page]="page"></viewer-pdf-toolbar>
<div class="msgWarning">{{ 'viewer-pdf.mensajeImpresion' | translate }}</div>
<div *ngIf="!showPdf" class="msgNoAccess">{{ 'viewer-pdf.mensajeAcceso' | translate }}</div>
<pdf-viewer [src]="src"
            [original-size]="true"
            [render-text]="true"
            [rotation]="0"
            [fit-to-page]="false"
            [zoom]="1"
            [zoom-scale]="'page-width'"
            [autoresize]="true"
            [show-borders]="true"
            (pagechanging)="pagechanging($event)"
            [(page)]="page"
            [(zoom)]="zoom"
            (after-load-complete)="afterLoadComplete($event)"
            class="pdf-viewer"
            *ngIf="showPdf"
></pdf-viewer>

